import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { Layout } from './components/Layout/Layout';
import { Home } from './pages/Home/Home';
import { Feed } from './pages/Feed/Feed';
import { SpotUpload } from './pages/SpotUpload/SpotUpload';
import { SpotDetail } from './pages/SpotDetail/SpotDetail';
import { SpotEdit } from './pages/SpotEdit/SpotEdit';
import { Garage } from './pages/Garage/Garage';
import { GarageCarDetail } from './pages/GarageCarDetail/GarageCarDetail';
import { GarageCarForm } from './pages/GarageCarForm/GarageCarForm';
import { FeaturedGarages } from './pages/FeaturedGarages/FeaturedGarages';
import { GaragesSearch } from './pages/GaragesSearch/GaragesSearch';
import { UserGarage } from './pages/UserGarage/UserGarage';
import { Login } from './pages/Login/Login';
import { CreateAccount } from './pages/CreateAccount/CreateAccount';
import { Favorites } from './pages/Favorites/Favorites';
import { MyFavorites } from './pages/MyFavorites/MyFavorites';
import { UserProfile } from './pages/UserProfile/UserProfile';
import { Badges } from './pages/Badges/Badges';
import { MostVoted } from './pages/MostVoted/MostVoted';
import { TopContributors } from './pages/TopContributors/TopContributors';
import { TopSpottersWeek } from './pages/TopSpottersWeek/TopSpottersWeek';
import { Profile } from './pages/Profile/Profile';
import { SearchSpots } from './pages/SearchSpots/SearchSpots';
import { Contact } from './pages/Contact/Contact';
import { About } from './pages/About/About';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DataProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="feed" element={<Feed />} />
              <Route path="spot" element={<SpotUpload />} />
              <Route path="spot/:id" element={<SpotDetail />} />
              <Route path="spot/:id/edit" element={<SpotEdit />} />
              <Route path="search" element={<SearchSpots />} />
              <Route path="garage" element={<Garage />} />
              <Route path="garage/new" element={<GarageCarForm />} />
              <Route path="garage/:id/edit" element={<GarageCarForm />} />
              <Route path="garage/:id" element={<GarageCarDetail />} />
              <Route path="garages/featured" element={<FeaturedGarages />} />
              <Route path="garages/search" element={<GaragesSearch />} />
              <Route path="garages/:username" element={<UserGarage />} />
              <Route path="garages/user/:userId" element={<UserGarage />} />
              <Route path="login" element={<Login />} />
              <Route path="create-account" element={<CreateAccount />} />
              <Route path="profile" element={<Profile />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="feedback" element={<Navigate to="/contact" replace />} />
              <Route path="favorites" element={<Favorites />} />
              <Route path="my-favorites" element={<MyFavorites />} />
              <Route path="badges" element={<Badges />} />
              <Route path="most-voted" element={<MostVoted />} />
              <Route path="top-contributors" element={<TopContributors />} />
              <Route path="top-spotters-week" element={<TopSpottersWeek />} />
              <Route path="user/:userId" element={<UserProfile />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </DataProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
